import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Form, Row, Col, Button, Alert, Spinner } from 'react-bootstrap';
import '../../../App.css';
import DatePicker from 'react-datepicker'
import '../../../vendor/libs/react-datepicker/react-datepicker.scss'
import '../../../vendor/libs/react-flatpickr/react-flatpickr.scss';
import * as api from '../../../api/api';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { stateToHTML } from 'draft-js-export-html';
import { rearg, result } from 'lodash';
import { event } from 'react-ga';
import * as actions from '../../../actions';

var dropdownInputs = {}
class OpportunityWebForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {
        email: '',
        phone: '',
        organization: '',
        position: '',
        location: '',
        salary: '',
        status: '',
        subjectId: '',
        gradeId: '',
        degreeOfEducation: '',
        vacancy: '',
        websiteLink: '',
        categories: [],
        orgImgLink: '',
        postApplyMsg: '',
        cutOffDate: '',
        opportunityTypeId: '',
        jobDescription: EditorState.createEmpty(),
        listingSequence: '',
        emailTemplateId: '',
        centaCriteria: '',
        active: 1,
        disabled: false,
        countryCode: '91',
        countryId: '1',
        firstName: '',
        lastName: '',
        working_organization: '',
        designation: '',
        otherDesignation: '',
        otp: ''
      },
      showLoader: false,
      isRenderingAllowed: true,
      opportunityTypes: [],
      opportunitySubjects: [],
      opportunityGrades: [],
      opportunityDegree: [],
      opportunityDesignation: [],
      errorMsg: '',
      opportunityId: this.props.opportunityId,
      opportunityData: '',
      errors: [],
      user: {
        accessToken: '',
        userId: '',
        role: '',
        userName: ''
      },
      countries: [],
      otpGenCount: 0,
      disableForm: true,
      showOtp: false,
      disableVerify: false,
      userType: '',
      phoneType: ''
    }
  }

  componentDidMount() {
    this.getCountries()
  }

  getCountries() {
    api.getResponse('', 'countries')
    .then((result) => {
      this.setState({ countries: result})
    })
  }

  getOpportunityTypes() {
    api.getResponse(this.props.user.accessToken, 'opportunity_types')
    .then((result) => {
      dropdownInputs.opportunityTypes = result
      this.getOpportunitySubjects()
    })
    .catch((err) => {
      this.setState({ errors: ['Exceptional Error'] })
    })
  }

  getOpportunitySubjects() {
    api.getResponse(this.props.user.accessToken, 'admin/subjects/lists')
    .then((result) => {
      if (result.status === 'success') {
        dropdownInputs.opportunitySubjects = result.data
        return this.getOpportunityGrades()
      }
      else if (result.status === 'error') {
        this.setState({ errors: [result.message] })
      }
      else if (result.errors) {
        this.setState({ errors: [result.errors] })
      }
      else {
        this.setState({ errors: ['Exceptional Error'] })
      }
    })
    .catch((err) => {
      this.setState({ errors: ['Exceptional Error'] })
    })
  }

  getOpportunityGrades() {
    api.getResponse(this.props.user.accessToken, 'grade')
      .then((result) => {
        if (result.status === 'success') {
          dropdownInputs.opportunityGrades = result.data
          this.getOpportunitydegree()
        }
        else if (result.status === 'error') {
          this.setState({ errors: [result.message] })
        }
        else if (result.errors) {
          this.setState({ errors: [result.errors] })
        }
        else {
          this.setState({ errors: ['Exceptional Error'] })
        }
      })
      .catch((err) => {
        this.setState({ errors: ['Exceptional Error'] })
      })
  }

  getOpportunitydegree() {
    let url = `fetch/info/list?name=DEGREE_OF_EDUCATION&type=additional_info`
    api.getResponse(this.props.user.accessToken, url)
      .then((result) => {
        if (result.status === 'success') {
          dropdownInputs.opportunityDegree = result.data
          this.getOpportunityDesignation()
        }
        else if (result.status === 'error') {
          this.setState({ errors: [result.message] })
        }
        else if (result.errors) {
          this.setState({ errors: [result.errors] })
        }
        else {
          this.setState({ errors: ['Exceptional Error'] })
        }
      })
      .catch((err) => {
        this.setState({ errors: ['Exceptional Error'] })
      })
  }

  getOpportunityDesignation() {
    let url = `fetch/info/list?name=POC_ROLE&type=additional_info`
    api.getResponse(this.props.user.accessToken, url)
    .then((result) => {
      if (result.status === 'success') {
        dropdownInputs.opportunityDesignation = result.data
        this.setState({
          opportunityTypes: dropdownInputs.opportunityTypes,
          opportunityCategories: dropdownInputs.opportunityCategories,
          opportunitySubjects: dropdownInputs.opportunitySubjects,
          opportunityGrades: dropdownInputs.opportunityGrades,
          opportunityDegree: dropdownInputs.opportunityDegree,
          opportunityDesignation: dropdownInputs.opportunityDesignation,
          userOtpError: '', disableForm: false,
          showOtp: false, showLoader: false
        })
      }
      else if (result.status === 'error') {
        this.setState({ errors: [result.message] })
      }
      else if (result.errors) {
        this.setState({ errors: [result.errors] })
      }
      else {
        this.setState({ errors: ['Exceptional Error'] })
      }
    })
    .catch((err) => {
      this.setState({ errors: ['Exceptional Error'] })
    })
  }

  handleChange = event => {
    let data = Object.assign({}, this.state.data)
    data[event.target.id] = event.target.value
    this.setState({ data: data })
  }

  handleDateChange = value => {
    let data = Object.assign({}, this.state.data)
    data.cutOffDate = value
    this.setState({ data });
  }

  handleEditorChange = editorState => {
    let data = Object.assign({}, this.state.data)
    data.jobDescription = editorState
    this.setState({ data });
  }

  isValidToSaveDraft = formData => {
    let errors = [], personalInfo, user, data = Object.assign({}, this.state.data),
        pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;

    personalInfo = formData.personal_info
    user = formData.user

    !personalInfo.first_name && errors.push('First Name is mandatory')
    !personalInfo.last_name && errors.push('Last Name is mandatory')
    if (!user.email) {
      errors.push('Email is mandatory')
    } else {
      if (!pattern.test(this.state.data.email)) {
        errors.push('Invalid Email Format')
      }
    }
    if (!user.phone) {
      errors.push('Mobile is mandatory')
    } else if (isNaN(user.phone)) {
      errors.push('Mobile should contain only numbers')
    }
    else if (data.countryId != '1') {
      if (user.phone.startsWith('91')) {
        errors.push('Mobile should not start with 91 for international user')
      } else if (user.phone.length < 7 || user.phone.length > 14) {
        errors.push('Mobile should contain 7 to 14 digits')
      }
    }
    !personalInfo.working_organization && errors.push('Name of School/ Organization is mandatory')
    if (!personalInfo.designation) {
      if (data.designation === 'Other') {
        errors.push('Other Designation is mandatory')
      } else {
        errors.push('Designation is mandatory')
      }
    }

    if (!formData.organization) {
      errors.push('School/Organization is mandatory')
    }
    if (formData.listing_sequence && isNaN(formData.listing_sequence)) {
      errors.push('Listing sequence should be a number')
    }
    this.setState({ errors, disableForm: errors.length < 1 })
    return errors.length < 1;
  }

  isValidToSubmit = formData => {
    let errors = [], personalInfo, user, data = Object.assign({}, this.state.data),
        pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;

    personalInfo = formData.personal_info
    user = formData.user

    !personalInfo.first_name && errors.push('First Name is mandatory')
    !personalInfo.last_name && errors.push('Last Name is mandatory')
    if (!user.email) {
      errors.push('Email is mandatory')
    } else {
      if (!pattern.test(this.state.data.email)) {
        errors.push('Invalid Email Format')
      }
    }
    if (!user.phone) {
      errors.push('Mobile is mandatory')
    } else if (isNaN(user.phone)) {
      errors.push('Mobile should contain only numbers')
    }
    else if (data.countryId != '1') {
      if (user.phone.startsWith('91')) {
        errors.push('Mobile should not start with 91 for international user')
      } else if (user.phone.length < 7 || user.phone.length > 14) {
        errors.push('Mobile should contain 7 to 14 digits')
      }
    }
    !personalInfo.working_organization && errors.push('Name of School/ Organization is mandatory')
    if (!personalInfo.designation) {
      if (data.designation === 'Other') {
        errors.push('Other Designation is mandatory')
      } else {
        errors.push('Designation is mandatory')
      }
    }
    !formData.organization && errors.push('School/Organization is mandatory')
    !formData.position && errors.push('Position is mandatory')
    !formData.location && errors.push('Location is mandatory')
    !formData.cut_off_date && errors.push('Last Date to Apply is mandatory')
    !formData.salary && errors.push('Salary is mandatory')
    !formData.vacancy && errors.push('No of vacancies is mandatory')
    !formData.opportunity_type_id && errors.push('Opportunity Type is mandatory')
    !formData.subject_id && errors.push('Subject is mandatory')
    !formData.grade_id && errors.push('Grade is mandatory')
    !formData.degree_of_education && errors.push('Degree of Education Needed is mandatory')
    !formData.centa_criteria && errors.push('CENTA Teaching Quotient Score is mandatory')
    // !formData.website_link && errors.push('Website Link is mandatory')
    // !formData.post_apply_msg && errors.push('Post apply message is mandatory')

    if (!formData.job_description) {
      errors.push('Job Description is mandatory')
    } else if (formData.job_description.length < 5) {
      errors.push('Job Description should have atleast 5 characters')
    }

    this.setState({ errors, disableForm: errors.length < 1 })

    return errors.length < 1
  }

  handleSaveDraft = (e) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data),
        formData = {
          'personal_info': {},
          'user': {}
        }
    let htmlText = stateToHTML(data.jobDescription.getCurrentContent())

    this.setState({ disableForm: true})
    if (data.organization) { formData.organization = data.organization }
    if (data.position) { formData.position = data.position }
    if (data.location) { formData.location = data.location }
    if (data.cutOffDate) { formData.cut_off_date = data.cutOffDate.toDateString() }
    if (data.salary) { formData.salary = data.salary }
    if (data.vacancy) { formData.vacancy = data.vacancy }
    if (data.opportunityTypeId) { formData.opportunity_type_id = data.opportunityTypeId }
    if (data.subjectId) { formData.subject_id = data.subjectId }
    if (data.gradeId) { formData.grade_id = data.gradeId }
    if (data.degreeOfEducation) { formData.degree_of_education = data.degreeOfEducation }
    if (data.centaCriteria) { formData.centa_criteria = data.centaCriteria }
    // if (data.websiteLink) { formData.website_link = data.websiteLink }
    // if (data.postApplyMsg) { formData.post_apply_msg = data.postApplyMsg }
    formData.active = data.active
    if (htmlText && htmlText !== '<p><br></p>') {
      formData.job_description = htmlText
    }
    formData.categories = ['4']
    if (data.firstName) { formData.personal_info.first_name = data.firstName }
    if (data.lastName) { formData.personal_info.last_name = data.lastName }
    if (data.designation) {
      if (data.designation === 'Other') {
        formData.personal_info.designation = data.otherDesignation
      }
      else {
        formData.personal_info.designation = data.designation
      }
    }
    if (data.email) { formData.user.email = data.email }
    if (data.phone) { formData.user.phone = data.phone }
    if (data.workingOrganization) { formData.personal_info.working_organization = data.workingOrganization }
    if (this.isValidToSaveDraft(formData)) {
      api.postValuesApi(this.props.user.accessToken, 'opportunities', formData)
        .then((result) => {
          if (result.status === 'success') {
            window.top.location.href = "/pwa/admin/post/home";
          }
          else if (result.status === 'error') {
            this.setState({ errorMsg: result.message, disableForm: false})
          }
          else if (result.errors) {
            this.setState({ errormsg: result.errors, disableForm: false})
          }
          else {
            this.setState({ errorMsg: 'Error in creating post', disableForm: false })
          }
        })
        .catch((result) => {
          this.setState({ errorMsg: 'Error in creating post', disableForm: false })
        })
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data), htmlText,
       formData = {
         'personal_info': {},
         'user': {}
       }

    this.setState({ disableForm: true})
    htmlText = stateToHTML(data.jobDescription.getCurrentContent())
    if (data.organization) { formData.organization = data.organization }
    if (data.position) { formData.position = data.position }
    if (data.location) { formData.location = data.location }
    if (data.cutOffDate) { formData.cut_off_date = data.cutOffDate.toDateString() }
    if (data.salary) { formData.salary = data.salary }
    if (data.vacancy) { formData.vacancy = data.vacancy }
    if (data.opportunityTypeId) { formData.opportunity_type_id = data.opportunityTypeId }
    if (data.subjectId) { formData.subject_id = data.subjectId }
    if (data.gradeId) { formData.grade_id = data.gradeId }
    if (data.degreeOfEducation) { formData.degree_of_education = data.degreeOfEducation }
    if (data.centaCriteria) { formData.centa_criteria = data.centaCriteria }
    // if (data.websiteLink) { formData.website_link = data.websiteLink }
    // if (data.postApplyMsg) { formData.post_apply_msg = data.postApplyMsg }
    if (htmlText && htmlText !== '<p><br></p>') {
      formData.job_description = htmlText
    }
    if (data.active) { formData.active = data.active }
    formData.workflow_status = 'submitted'
    formData.categories = ['4']
    if (data.firstName) { formData.personal_info.first_name = data.firstName}
    if (data.lastName) { formData.personal_info.last_name = data.lastName}
    if (data.designation) {
      if (data.designation === 'Other') {
        formData.personal_info.designation = data.otherDesignation
      }
      else {
        formData.personal_info.designation = data.designation
      }
    }
    if (data.email) { formData.user.email = data.email}
    if (data.phone) { formData.user.phone = data.phone}
    if (data.workingOrganization) { formData.personal_info.working_organization = data.workingOrganization}
    if (this.isValidToSubmit(formData)) {
      api.postValuesApi(this.props.user.accessToken, 'opportunities', formData)
        .then((result) => {
          if (result.status === 'success') {
            this.setState({ errorMsg: ''})
            window.top.location.href = "/pwa/admin/post/home";
          }
          else if (result.status === 'error') {
            this.setState({ errorMsg: result.message, disableForm: false})
          }
          else if (result.errors) {
            this.setState({ errorMsg: result.errors, disableForm: false})
          }
          else {
            this.setState({ errorMsg: 'Error in creating Post', disableForm: false })
          }
        })
        .catch((result) => {
          this.setState({ errorMsg: 'Error in creating Post', disableForm: false })
        })
    }
  }

  getErrorMessage() {
    let errorMessage
    if (this.state.errors.length < 1) { return '' }
    errorMessage = (
      <Alert className="mt-2" variant="danger" style={{ width: '70%' }}>
        {this.state.errors.map((error) => (
          <span>
            {error}
            <br />
          </span>
        ))}
      </Alert>
    )
    return errorMessage
  }

  handleCountriesChange = (event) => {
    let data = Object.assign({}, this.state.data)
    data.countryId = event.target.value
    data.phone = ''
    data.email = ''
    if (data.countryId == '1') {
      data.countryCode = '91'
    }
    else {
      data.countryCode = ''
    }
    this.setState({ data: data, verifyError: '' })
  }

  validateVerifyUser() {
    let data = Object.assign({}, this.state.data), isvalid = true, msg = '', phoneno

    if (data.countryId == '1' && !data.phone) {
      phoneno = /^\d{12}$/;
      let fullPhoneNumber = data.countryCode + data.phone
      if (!fullPhoneNumber.match(phoneno)) {
        msg = 'Mobile is mandatory.'
        isvalid = false
      }
    }
    else if (data.countryId == '1' && data.phone) {
      phoneno = /^\d{10}$/;
      let fullPhoneNumber = data.phone
      if (!fullPhoneNumber.match(phoneno)) {
        msg = 'Please enter a valid 10 digit Mobile Number.'
        isvalid = false
      }
    }
    else {
      if (!(data.email)) {
        msg = 'Email is mandatory'
        isvalid = false
      } else {
        var pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
        if (!pattern.test(this.state.data.email)) {
          msg = 'Invalid Email Format'
          isvalid = false
        }
      }
    }
    this.setState({verifyError: msg, disableVerify: isvalid})

    return isvalid
  }

  verifyUser = () => {
    let data = Object.assign({}, this.state.data), url = 'centa/registration/otp/gen', requestData

    this.setState({ verifyError: '', userOtpError: '', disableVerify: true, showLoader: true})
    if (!this.validateVerifyUser()) {
      return
    }
    if (this.state.otpGenCount > 4) {
      this.setState({ 
        verifyError: 'You have exceeded maximum number of OTP regenerations allowed.',
        showLoader: false
      })
      return
    }
    requestData = {
      'user': {
        'country_id': parseInt(data.countryId),
        'country_code': data.countryCode,
        'role': 'school_organization_admin'
      }
    }
    if (data.countryId == '1') {
      requestData.user.phone = data.phone
    }
    else {
      requestData.user.email = data.email
    }
    api.postValuesApi('', url, requestData)
    .then((result) => {
      if (result.status === 'success') {
        this.setState({
          verifyError: '', otpGenCount: this.state.otpGenCount + 1,
          showOtp: true, disableVerify: true,
          userType: result.data.user_type,
          phoneType: result.data.phone_type, showLoader: false
        })
      }
      else if (result.status === 'error') {
        this.setState({ verifyError: result.message, disableVerify: false, showLoader: false})
      }
      else if (result.errors) {
        this.setState({ verifyError: result.errors, disableVerify: true, showLoader: false })
      }
    })
    .catch((err) => {
      this.setState({ verifyError: 'Exceptional error', disableVerify: true, showLoader: false})
    })
  }

  processReduxStorage = (user_name, accessToken, userId, role) => {
    const obj = {
      'accessToken': accessToken,
      'userName': user_name,
      'id': userId,
      'role': role
    }
    this.props.userLogin(obj)
  }

  handleConfirmOtp = () => {
    let otpValidation = /^\d{6}$/, url, requestData,
      otpprovided, data = Object.assign({}, this.state.data),
      responseData, user = Object.assign({}, this.state.user)
        
    this.setState({ userOtpError: '', verifyError: ''})
    otpprovided = data.otp
    if (!otpprovided) {
      this.setState({ userOtpError: 'Please enter OTP Code' })
    }
    else if (otpprovided.match(otpValidation)) {
      this.setState({ showLoader: true})
      url = 'centa/registration/otp/confirm'
      requestData = {
        'reg_type': 'Opportunity',
        'country_code': data.countryCode,
        'otp_code': data.otp,
        'user_type': this.state.userType,
        'phone_type': this.state.phoneType,
        'country_id': parseInt(data.countryId)
      }
      if (data.countryId == '1') {
        requestData.phone = data.phone
      } else {
        requestData.email = data.email
      }
      api.postValuesApiWithHeaders('', url, requestData)
      .then((result) => {
        if (result.status === 'success') {
          responseData = result.data
          if (responseData.role !== 'school_organization_admin') {
            this.setState({ userOtpError: 'Role is not School/ Organization admin'})
            return
          }
          user.userId = responseData.user_id
          user.userName = responseData.user_name
          user.role = responseData.role
          user.accessToken = result.headers.accessToken
          this.processReduxStorage(responseData.user_name, result.headers.accessToken, responseData.user_id, responseData.role)
          if (this.state.userType === 'existing user' && responseData.opp_available === 'yes') {
            window.top.location.href = "/pwa/admin/post/home";
          } else {
            if (responseData.phone) {
              data.phone = responseData.phone
            }
            this.getOpportunityTypes()
            this.setState({
              data, user
            })
          }
        }
        if (result.status === 'error') {
          this.setState({ userOtpError: result.message, showLoader: false})
        }
        if (result.errors) {
          this.setState({ userOtpError: result.errors, showLoader: false })
        }
      })
      .catch((err) => {
        this.setState({ userOtpError: 'Exceptional Error', showLoader: false })
      })
    } else {
      this.setState({ userOtpError: 'Please enter a valid OTP Code', showLoader: false})
    }
  }

  render() {
    let errorContainer, labelStyle, inputComponent,
        otpComponent, personalInfoComponent, loaderComponent
    labelStyle = {
      fontSize: '15px',
      marginBottom: 0
    }
    if (this.state.showLoader) {
      loaderComponent = (
        <div align="center">
          <Spinner animation="border" /><span>Please wait..</span>
        </div>
      )
    }
    if (this.state.data.countryId == '1') {
      inputComponent = (
        <React.Fragment>
          <Row className="mt-3">
            <Col><Form.Label style={ labelStyle }>Mobile</Form.Label></Col>
          </Row>
          <Row>
            <Col xs="3" md="2">
              <Form.Control
                id="countryCode"
                name="countryCode"
                value={this.state.data.countryCode}
                onChange={this.handleChange}
                disabled={true}
                style={{ width: "100%"}}
              />
            </Col>
            <Col xs="6" md="3">
              <Form.Control
                id="phone"
                name="phone"
                value={this.state.data.phone}
                onChange={this.handleChange}
                disabled={this.state.disableVerify}
              />
            </Col>
            <Col><Button onClick={this.verifyUser} disabled={this.state.disableVerify}>VERIFY</Button></Col>
          </Row>
          <Row className="mt-3">
            <Col>An OTP will be sent to your mobile once you click on VERIFY. Please enter it below.</Col>
          </Row>
          { this.state.verifyError &&
            <Alert className="mt-2" variant="danger" style={{ width: '70%' }}>
              {this.state.verifyError}
            </Alert>
          }
        </React.Fragment>
      )
    } else {
      inputComponent = (
        <React.Fragment>
          <Row className="mt-3">
            <Col><Form.Label style={labelStyle}>Email</Form.Label></Col>
          </Row>
          <Row>
            <Col md="3">
              <Form.Control
                id="email"
                name="email"
                value={this.state.data.email}
                onChange={this.handleChange}
                disabled={this.state.disableVerify}
              />
            </Col>
            <Col><Button onClick={this.verifyUser} disabled={this.state.disableVerify}>VERIFY</Button></Col>
          </Row>
          <Row className="mt-3">
            <Col>An OTP will be sent to your email once you click on VERIFY. Please enter it below.</Col>
          </Row>
          { this.state.verifyError &&
            <Alert className="mt-2" variant="danger" style={{ width: '70%' }}>
              {this.state.verifyError}
            </Alert>
          }
        </React.Fragment>
      )
    }

    otpComponent = this.state.showOtp ? (
      <React.Fragment>
        { this.state.userOtpError &&
          <Alert className="mt-2" variant="danger" style={{ width: '70%' }}>
            {this.state.userOtpError}
          </Alert>
        }
        <Row className="mt-3">
          <Col><Form.Label style={labelStyle}>Enter OTP</Form.Label></Col>
        </Row>
        <Row className="mt-2">
          <Col className="mr-2" xs="12" sm="6" md="2">
            <Form.Control
              id="otp"
              name="otp"
              value={this.state.data.otp}
              onChange={this.handleChange}
              autoComplete="off"
            />
          </Col>
          <Col md="2"><Button onClick={this.handleConfirmOtp} disabled={this.state.showLoader}>CONFIRM OTP</Button></Col>
          <Col md="2"><Button onClick={this.verifyUser} disabled={this.state.showLoader}>REGENERATE OTP</Button></Col>
          {loaderComponent}
        </Row>
      </React.Fragment>
    ) : null

    personalInfoComponent = (
        <Alert className="mt-2" variant="secondary">
        <Form.Label className="mt-2" style={labelStyle}>Details of the POC:</Form.Label>
        <Row className="mt-3">
          <Col className="mr-5" xs="12" sm="6" md="3">
            <Form.Label style={labelStyle}>First Name</Form.Label>
            <Form.Control
              id="firstName"
              name="first_name"
              value={this.state.data.firstName}
              onChange={this.handleChange}
              disabled={this.state.disableForm}
            />
          </Col>
          <Col xs="12" sm="6" md="3">
            <Form.Label style={labelStyle}>Last Name</Form.Label>
            <Form.Control
              id="lastName"
              name="last_name"
              value={this.state.data.lastName}
              onChange={this.handleChange}
              disabled={this.state.disableForm}
            />
          </Col>
        </Row>
        <Row className="mt-3">
          { this.state.data.countryId == '1' ?
            (<Col className="mr-5" xs="12" sm="6" md="3">
              <Form.Label style={labelStyle}>Email</Form.Label>
              <Form.Control
                id="email"
                name="email"
                value={this.state.data.email}
                onChange={this.handleChange}
                disabled={this.state.disableForm}
              />
            </Col>) :
            (<Col className="mr-5" xs="12" sm="6" md="3">
              <Form.Label style={labelStyle}>Mobile</Form.Label>
              <Form.Control
                id="phone"
                name="phone"
                value={this.state.data.phone}
                onChange={this.handleChange}
                disabled={this.state.disableForm}
              />
            </Col>)
          }
          <Col className="mr-5" xs="12" sm="6" md="3">
            <Form.Label style={labelStyle}>Name of School/ Organization</Form.Label>
            <Form.Control
              id="workingOrganization"
              name="working_organization"
              value={this.state.data.workingOrganization}
              onChange={this.handleChange}
              disabled={this.state.disableForm}
            />
          </Col>
        </Row>
        <Row className="mt-3">
          <Col className="mr-5" xs="12" sm="6" md="3">
          <Form.Label style={labelStyle}>Designation</Form.Label>
          
                  
          <select
            id="designation"
            name="designation"
            className="infoSave active"
            style={{ width: '100%' }}
            onChange={this.handleChange}
            value={this.state.data.designation}
            disabled={this.state.disableForm}>
            <option value="">Select</option>
              {this.state.opportunityDesignation && this.state.opportunityDesignation.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
            </Col>
          { this.state.data.designation == 'Other' &&
            <Col className="mr-5" xs="12" sm="6" md="3">
              <Form.Label style={labelStyle}>Please mention</Form.Label>
              <Form.Control
                id="otherDesignation"
                name="otherDesignation"
                value={this.state.data.otherDesignation}
                onChange={this.handleChange}
                disabled={this.state.data.disableForm}
              />
            </Col>
          }
        </Row>
      </Alert>
    )
    errorContainer = this.getErrorMessage()

    return (
      <React.Fragment>
        <Container className="mt-3 mb-3">
        <h4 className="text-center mt-3">Opportunity Posting Form</h4>
          <Form>
            <Row className="mt-3">
              <Col className="mr-5" xs="12" sm="6" md="3">
                <Form.Label style={labelStyle}>Country</Form.Label>
                <select
                  id="country"
                  name="country"
                  className="infoSave active"
                  style={{ width: '100%' }}
                  onChange={this.handleCountriesChange}
                  value={this.state.data.countryId}
                  disabled={this.state.disableVerify}
                >
                  <option value="">Select</option>
                  {this.state.countries && this.state.countries.map((type) => (
                    <option key={type.id} value={type.id} data-name={type.name}>
                      {type.name}
                    </option>
                  ))}
                </select>
              </Col>
            </Row>
            {inputComponent}
            {otpComponent}
            { !this.state.disableForm &&
              <Alert variant="info"><b>Welcome!</b> Your Username is <u><b>{this.state.user.userName}</b></u>. Please make a note of this.</Alert>
            }
            {personalInfoComponent}
            <Alert className="mt-2" variant="secondary">
            <Form.Label style={labelStyle}>Details of the Post:</Form.Label>
            <Row className="mt-3">
              <Col className="mr-5" xs="12" sm="6" md="3">
                <Form.Label style={labelStyle}>School/ Organization</Form.Label>
                <Form.Control
                  id="organization"
                  name="organization"
                  value={this.state.data.organization}
                  onChange={this.handleChange}
                  disabled={this.state.disableForm}
                />
              </Col>
              <Col xs="12" sm="6" md="3">
                <Form.Label style={labelStyle}>Position</Form.Label>
                <Form.Control
                  id="position"
                  name="position"
                  value={this.state.data.position}
                  onChange={this.handleChange}
                  disabled={this.state.disableForm}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col className="mr-5" xs="12" sm="6" md="3">
                <Form.Label style={labelStyle}>Location</Form.Label>
                <Form.Control
                  id="location"
                  name="location"
                  value={this.state.data.location}
                  onChange={this.handleChange}
                  disabled={this.state.disableForm}
                />
              </Col>
              <Col xs="12" sm="6" md="3">
                <Form.Label style={labelStyle}>Last Date to Apply</Form.Label>
                <DatePicker
                  className="form-control"
                  id="cutOffDate"
                  name="cut_off_date"
                  dateFormat="dd/MM/yyyy"
                  selected={this.state.data.cutOffDate}
                  onChange={this.handleDateChange}
                  autoComplete="off"
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  popperPlacement={'top-start'}
                  minDate={new Date}
                  disabled={this.state.disableForm}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col className="mr-5" xs="12" sm="6" md="3">
                <Form.Label style={labelStyle}>Salary (Monthly in INR)</Form.Label>
                <Form.Control
                  id="salary"
                  name="salary"
                  value={this.state.data.salary}
                  onChange={this.handleChange}
                  disabled={this.state.disableForm}
                />
              </Col>
              <Col xs="12" sm="6" md="3">
                <Form.Label style={labelStyle}>Number of Vacancies</Form.Label>
                <Form.Control
                  id="vacancy"
                  name="vacancy"
                  value={this.state.data.vacancy}
                  onChange={this.handleChange}
                  disabled={this.state.disableForm}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col className="mr-5" xs="12" sm="6" md="3">
                <Form.Label style={labelStyle}>Opportunity Type</Form.Label>
                <select
                  id="opportunityTypeId"
                  name="opportunity_type_id"
                  className="infoSave active"
                  style={{ width: '100%' }}
                  onChange={this.handleChange}
                  value={this.state.data.opportunityTypeId}
                  disabled={this.state.disableForm}
                >
                  <option value="">Select</option>
                  {this.state.opportunityTypes && this.state.opportunityTypes.map((type) => (
                    <option key={type.id} value={type.id} data-name={type.name}>
                      {type.name}
                    </option>
                  ))}
                </select>
              </Col>
              <Col xs="12" sm="6" md="3">
                <Form.Label style={labelStyle}>Subject</Form.Label>
                <select
                  id="subjectId"
                  name="subject_id"
                  className="infoSave active"
                  style={{ width: '100%' }}
                  onChange={this.handleChange}
                  value={this.state.data.subjectId}
                  disabled={this.state.disableForm}
                >
                  <option value="">Select</option>
                  {this.state.opportunitySubjects && this.state.opportunitySubjects.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.display_name}
                    </option>
                  ))}
                </select>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col className="mr-5" xs="12" sm="6" md="3">
                <Form.Label style={labelStyle}>Grade</Form.Label>
                <select
                  id="gradeId"
                  name="grade_id"
                  value={this.state.data.gradeId}
                  className="infoSave active"
                  style={{ width: '100%' }}
                  onChange={this.handleChange}
                  disabled={this.state.disableForm}
                >
                  <option value="">Select</option>
                  {this.state.opportunityGrades && this.state.opportunityGrades.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
              </Col>
              <Col xs="12" sm="6" md="3">
                <Form.Label style={labelStyle}>Degree of Education Needed</Form.Label>
                <select
                  id="degreeOfEducation"
                  name="degree_of_education"
                  value={this.state.data.degreeOfEducation}
                  onChange={this.handleChange}
                  className="infoSave active"
                  style={{ width: '100%' }}
                  disabled={this.state.disableForm}
                >
                  <option value="">Select</option>
                  {this.state.opportunityDegree && this.state.opportunityDegree.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col className="mr-5" xs="12" sm="6" md="8">
                <Form.Label style={labelStyle}>What CENTA Teaching Quotient Score would you prefer? The national average is currently 40 on 100.</Form.Label>
                <Form.Control
                  id="centaCriteria"
                  name="centa_criteria"
                  value={this.state.data.centaCriteria}
                  onChange={this.handleChange}
                  disabled={this.state.disableForm}
                />
              </Col>
            </Row>
            {/*<Row className="mt-3">
              <Col xs="12" sm="6" md="8">
                <Form.Label style={labelStyle}>Website Link</Form.Label>
                <Form.Control
                  id="websiteLink"
                  name="website_link"
                  value={this.state.data.websiteLink}
                  onChange={this.handleChange}
                  disabled={this.state.disableForm}
                />
              </Col>
            </Row>/*}
            {/* <Row className="mt-3">
              <Col xs="12" sm="6" md="8">
                <Form.Label style={labelStyle}>Organization Image Link</Form.Label>
                <Form.Control
                  id="orgImgLink"
                  name="org_img_link"
                  value={this.state.data.orgImgLink}
                  onChange={this.handleChange}
                  disabled={this.state.disableForm}
                />
              </Col>
            </Row> *
            <Row className="mt-3">
              <Col xs="12" sm="6" md="8">
                <Form.Label style={labelStyle}>Post Apply Message</Form.Label>
                <Form.Control
                  id="postApplyMsg"
                  name="post_apply_msg"
                  value={this.state.data.postApplyMsg}
                  onChange={this.handleChange}
                  disabled={this.state.disableForm}
                />
              </Col>
            </Row>*/}
            <Row className="mt-3">
              <Col xs="12" sm="6" md="8">
                <Form.Label style={labelStyle}>Job Description - Please type in a brief description of the Opportunity (in less than 1000 characters)</Form.Label>
                <Editor
                  editorState={this.state.data.jobDescription}
                  id="jobDescription"
                  name="job_description"
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor"
                  onEditorStateChange={this.handleEditorChange}
                  toolbar={{
                    options: ['inline', 'list'],
                    link: { inDropdown: true },
                    inline:
                    {
                      options: ['bold', 'italic', 'underline']
                    }
                  }}
                  editorStyle={{ background: "#fff" }}
                  readOnly={this.state.disableForm}
                />
              </Col>
            </Row>
            </Alert>
            {errorContainer}
            {this.state.errorMsg &&
              <Alert className="mt-2" variant="danger" style={{ width: '70%' }}>
                {this.state.errorMsg}
              </Alert>
            }
            <Row className="mt-3">
              <Col xs="5" sm="6" md="2">
                <Button variant="primary" onClick={this.handleSaveDraft} disabled={this.state.disableForm}>Save as draft</Button>
              </Col>
              <Col xs="3" sm="6" md="2">
                <Button variant="primary" onClick={this.handleSubmit} disabled={this.state.disableForm}>Submit</Button>
              </Col>
            </Row>
          </Form>
        </Container>
      </React.Fragment>
    )
  }
}

function mapStateToProps({ user }) {
  return {
    user
  }
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: data => dispatch(actions.userLogin(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OpportunityWebForm);